import { GE_THEME } from '../theme/common/default';
import { COMMON_AXISLABEL_FORMATTER } from '../theme/common/base';
export var option = {
  grid: {
    left: 50,
    right: 20
  },
  yAxis: {
    axisLabel: {
      show: true,
      margin: 10,
      formatter: COMMON_AXISLABEL_FORMATTER
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    }
  },
  tooltip: GE_THEME.GE_TOOLTIP,
  series: []
};